module.exports = __webpack_public_path__ + "img/withdraw.33635227.svg";